$(document).ready(function() {
  window.addEventListener('savvior:destroy', function(e) {
    setup_gridview();
  });

  window.addEventListener('savvior:setup', function(e) {
    $.cloudinary.responsive();
  });

  updateResponsiveElements();
  $('body').on('click', '.user-like', function(event) {
    if (typeof $(event.target).data('id') !== 'undefined'){
      $('[data-id='+$(event.target).data('id')+']').toggleClass('action-active')
    } else {
      $(event.target).toggleClass('action-active')
    }

  })
});

function setup_gridview(){
  // Foundation's .column {width:100%} needs a .row parent to be overridden
  // by savvior's .size-1ofN classes. Add it before init so columns render correctly.
  $('.ais-Hits-list').addClass('row');
  savvior.init('.ais-Hits-list', {
    'screen and (max-width: 640px)': {
      columns: 1
    },
    'screen and (min-width: 641px) and (max-width: 1024px)': {
      columns: 2
    },
    'screen and (min-width: 1025px) and (max-width: 1280px)': {
      columns: 3
    },
    'screen and (min-width: 1281px) and (max-width: 1599px)': {
      columns: 4
    },
    'screen and (min-width: 1600px) and (max-width: 2200px)': {
      columns: 5
    },
    'screen and (min-width: 2201px)': {
      columns: 6
    }
  });
}

$(document).on('click', '.view-mode a:not(.grid-list-toggler)', function(){
  var selectedViewMode = $(this).data('view');
  $('.view-mode a').removeClass('active');
  $('.view-mode a[data-view="' + selectedViewMode + '"]').addClass('active');
  $('#view').val(selectedViewMode);

  // appendLoader('.view-container');

  var queryString = window.location.search.replace(/&?view=([^&]$|[^&]*)/i, "")
  queryString = new URI(queryString).removeSearch(['project_type', 'sortBy']).toString()

  if(queryString.trim().length == 0 || queryString.trim() == '?'){
   queryString = "?view=" + selectedViewMode
  }
  else{
    queryString = queryString + "&view=" + selectedViewMode
  }

  if($('#description').is(':checked')){
    queryString = queryString + "&description=1"
  }

  var activeViewParam = '';
  if ($('#projects-smart-lists').length > 0) {
    var activeView = $('#projects-smart-lists ul#quick-lists li a.selected').data('type');

    switch(activeView) {
      case 'follower_ids':
        activeViewParam = '&project_type=liked'; break;
      case 'verified-projects':
        activeViewParam = '&project_type=verified-projects'; break;
      case 'all-projects':
        activeViewParam = '&project_type=all-projects'; break;
    }
    window.location = window.location.pathname + queryString + activeViewParam + '&' + PublicIndexesProjectsWidgets.getQuery()
  } else if ($('#companies-smart-lists').length > 0) {
    var activeView = $('#companies-smart-lists ul#quick-lists li a.selected').data('type');

    switch(activeView) {
      case 'follower_ids':
        activeViewParam = '&company_type=liked'; break;
      case 'all-companies':
        activeViewParam = '&company_type=all-companies'; break;
    }
    window.location = window.location.pathname + queryString + activeViewParam
  } else {
    window.location = window.location.pathname + queryString
  }

  location.hash = ''
  return false;
});

$(document).on('click', '.toggle-map-filters', function(){
  $('.map-filters').toggle();
});

$(document).on('click', '.close-map-filters', function(){
  $('.map-filters').hide();
});

function setup_cp_gridview(){
  savvior.init('#company-projects-grid', {
    'screen and (max-width: 640px)': {
      columns: 1
    },
    'screen and (min-width: 641px) and (max-width: 1024px)': {
      columns: 3
    },
    'screen and (min-width: 1025px) and (max-width: 1280px)': {
      columns: 4
    },
    'screen and (min-width: 1281px) and (max-width: 1600px)': {
      columns: 5
    },
    'screen and (min-width: 1601px)': {
      columns: 6
    }
  });
}

$(document).on('click', '#export-projects', function(){
  queryString = window.location.search.replace(/&?format=([^&]$|[^&]*)/i, "")

  if(queryString.trim().length == 0 || queryString.trim() == '?'){
    queryString = "?format=xlsx"
  }
  else{
    if($('#description').is(':checked')){
      queryString = queryString + "&description=1"
    }
    queryString = queryString + "&additional_filters="+PublicIndexesProjectsWidgets.getQuery();
    queryString = queryString + "&format=xlsx"
  }

  window.location.href = window.location.pathname + queryString
})

function insertParam(key, value) {
  key = escape(key); value = escape(value);
  var search = "";
  var kvp = document.location.search.substr(1).split('&');
  if (kvp == '') {
    search = '?' + key + '=' + value;
  }
  else {

      var i = kvp.length; var x; while (i--) {
          x = kvp[i].split('=');

          if (x[0] == key) {
              x[1] = value;
              kvp[i] = x.join('=');
              break;
          }
      }

      if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

      //this will reload the page, it's likely better to store this until finished
      search = "?" + kvp.join('&');
  }

  return window.location.pathname + search + window.location.hash;
}

// Expose to window for cross-module access (Sprockets global → esbuild module scope fix)
window.setup_gridview = setup_gridview;
window.setup_cp_gridview = setup_cp_gridview;
window.insertParam = insertParam;
